"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1240],{

/***/ 11240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ UnderPriceRangeSection_UnderPriceRangeSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./contexts/AnalyticsProvider.tsx
var AnalyticsProvider = __webpack_require__(76998);
// EXTERNAL MODULE: ./helper/helper.ts
var helper = __webpack_require__(48229);
// EXTERNAL MODULE: ./localization/common.ts + 24 modules
var common = __webpack_require__(86438);
// EXTERNAL MODULE: ./redux/hooks.ts
var hooks = __webpack_require__(16410);
// EXTERNAL MODULE: ./utils/eventTracking.ts
var eventTracking = __webpack_require__(77094);
// EXTERNAL MODULE: ./utils/formatBigNumber.ts
var formatBigNumber = __webpack_require__(31305);
// EXTERNAL MODULE: ./utils/localizationUtils.ts
var localizationUtils = __webpack_require__(26754);
// EXTERNAL MODULE: ./utils/we.ts + 2 modules
var we = __webpack_require__(77534);
// EXTERNAL MODULE: ./components/ProductSection/ProductSectionNewStyle.tsx
var ProductSectionNewStyle = __webpack_require__(78486);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./constants/screenResolution.ts
var screenResolution = __webpack_require__(83552);
;// CONCATENATED MODULE: ./components/UnderPriceRangeSection/UnderPriceRangeSectionStyles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1232px;\n  margin: 0 auto 32px;\n  margin-bottom: 0;\n  padding: 0 16px;\n  @media (max-width: ",
        ") {\n    margin: 0 0 24px;\n  }\n  @media (max-width: ",
        ") {\n    margin: 0px;\n    margin-bottom: 0px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(179px, 1fr));\n  position: relative;\n  place-items: center;\n  // padding: 16px;\n  width: 100%;\n  grid-gap: 16px;\n  // box-shadow: ",
        ";\n  // background: ",
        ";\n  // border-radius: ",
        ";\n  @media (max-width: ",
        ") {\n    // grid-gap: 12px;\n    // grid-template-columns: repeat(auto-fill, minmax(107px, 1fr));\n    grid-template-columns: 1fr 1fr;\n    // background: ",
        ";\n    box-shadow: none;\n    place-items: normal;\n    grid-gap: 12px;\n    padding: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // min-height: 118px;\n  // min-width: 179px;\n  width: 189px;\n  height: 104px;\n  padding: 16px;\n  cursor: pointer;\n  border-radius: 16px;\n  background: ",
        ";\n  // box-shadow: ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  display: grid;\n  place-items: center;\n  place-content: center;\n  font-family: Roobert-Bold;\n  font-size: 32px;\n  line-height: 36px;\n  // color: ",
        ";\n  text-align: center;\n  // background: ",
        ";\n  background-size: 150% 100%;\n  background-position: center;\n  transition: 0.3s;\n  & span {\n    font-size: 16px;\n    font-family: Roobert-Medium;\n    color: ",
        ";\n    line-height: 20px;\n  }\n  &:hover {\n    // transform: translateY(-5px);\n    background: ",
        ";\n    background-position: 100% 50%;\n  }\n  &:active {\n    transform: scale(0.96);\n  }\n\n  @media (max-width: ",
        ") {\n    min-width: 107px;\n    min-height: 59px;\n    width: 100%;\n    height: 100%;\n    font-size: 15px;\n    line-height: 15px;\n    padding: 8px;\n    background-size: 100% 100%;\n\n    &:hover {\n      transform: none;\n      background-position: none;\n    }\n    &:active {\n      transform: scale(0.96);\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var UnderPriceRangeSectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UnderPriceRangeSectionStyles__UnderPriceRangeSectionContainer",
    componentId: "sc-5a6ced6c-0"
})(_templateObject(), function(props) {
    return props.theme.palette.background.bg2;
});
var UnderPriceRangeSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UnderPriceRangeSectionStyles__UnderPriceRangeSectionWrapper",
    componentId: "sc-5a6ced6c-1"
})(_templateObject1(), screenResolution/* WIDTH.tabletMax */.m.tabletMax, screenResolution/* WIDTH.mobileMax */.m.mobileMax);
var MainSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "UnderPriceRangeSectionStyles__MainSection",
    componentId: "sc-5a6ced6c-2"
})(_templateObject2(), function(props) {
    return props.theme.shadows.s2;
}, function(props) {
    return props.theme.palette.background.bg1;
}, function(props) {
    return props.theme.palette.borderRadius.b4;
}, screenResolution/* WIDTH.mobileMax */.m.mobileMax, function(props) {
    return props.theme.palette.background.bg2;
});
var PriceTile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UnderPriceRangeSectionStyles__PriceTile",
    componentId: "sc-5a6ced6c-3"
})(_templateObject3(), function(props) {
    return props.theme.palette.button.grey.main;
}, function(props) {
    return props.theme.shadows.s2;
}, function(props) {
    return props.theme.palette.divider.d1;
}, function(props) {
    return props.theme.palette.text.t1;
}, function(props) {
    return props.theme.palette.white.main;
}, function(props) {
    return props.bg;
}, function(props) {
    return props.theme.palette.text.t3;
}, function(props) {
    return props.theme.palette.button.grey.hover;
}, screenResolution/* WIDTH.mobileMax */.m.mobileMax);

;// CONCATENATED MODULE: ./components/UnderPriceRangeSection/UnderPriceRangeSection.tsx














var UnderPriceRangeSection = function(param) {
    var idString = param.idString;
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    var global = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.global;
    });
    var cleverTap = (0,AnalyticsProvider/* useAnalytics */.z)().cleverTap;
    var useLocale = (0,localizationUtils/* getLocaleToBeUsed */.mA)(locale);
    var _useLocale = common/* CommonMessages */.E[useLocale], explore_by_price_msg = _useLocale.explore_by_price_msg, under_msg = _useLocale.under_msg, discover_by_price_msg = _useLocale.discover_by_price_msg;
    var ref = (0,react.useState)([]), rangeList = ref[0], setRangeList = ref[1];
    (0,react.useEffect)(function() {
        if (global.locationDetails) {
            var list = (0,helper/* getFilterList */.oG)(global.locationDetails.multiplier);
            setRangeList(list);
        }
    }, [
        global.locationDetails
    ]);
    // const handleTileClick = useCallback(
    //   (maxPrice: number, minPrice: number) => {
    //     const maxPriceFinal = (maxPrice / global.locationDetails.multiplier)
    //       .toFixed(2)
    //       .toString();
    //     const minPriceFinal = (minPrice / global.locationDetails.multiplier)
    //       .toFixed(2)
    //       .toString();
    //     router.push({
    //       pathname: '/store',
    //       query: {
    //         page: 1,
    //         priceMax: maxPriceFinal,
    //         priceMin: minPriceFinal,
    //       },
    //     });
    //   },
    //   [global.locationDetails, router]
    // );
    var getTileLink = (0,react.useCallback)(function(maxPrice, minPrice) {
        var maxPriceFinal = (maxPrice / global.locationDetails.multiplier).toFixed(2).toString();
        var minPriceFinal = (minPrice / global.locationDetails.multiplier).toFixed(2).toString();
        return "/store?page=1&priceMax=".concat(maxPriceFinal, "&priceMin=").concat(minPriceFinal);
    }, [
        global.locationDetails,
        router
    ]);
    var bgList = [
        "repeating-linear-gradient(135deg, #ABDCFF 0%, #0396FF 100%, #ABDCFF 0%)",
        "repeating-linear-gradient(135deg, #FAD7A1 0%, #E96D71 100%, #FAD7A1 0%)",
        "repeating-linear-gradient(135deg, #2AFADF 0%, #4C83FF 100%, #2AFADF 0%)",
        "repeating-linear-gradient(135deg, #CE9FFC 0%, #7367F0 100%, #CE9FFC 0%)",
        "repeating-linear-gradient(135deg, #FAB2FF 0%, #1904E5 100%, #FAB2FF 0%)",
        "repeating-linear-gradient(135deg, #F6D242 0%, #FF52E5 100%, #F6D242 0%)", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UnderPriceRangeSectionContainer, {
        id: idString,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnderPriceRangeSectionWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSectionNewStyle/* ProductSectionTitle */.eC, {
                    children: discover_by_price_msg
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSection, {
                    children: rangeList.map(function(cur, i) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                            passHref: true,
                            href: getTileLink(cur, rangeList[i - 1] || 0),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceTile, {
                                    bg: bgList[i],
                                    onClick: function() {
                                        var ref, ref1, ref2;
                                        (0,eventTracking/* saveEventV3 */.kY)({
                                            category: "collection_card",
                                            action: "click",
                                            label: "explore_by_price",
                                            properties: "collection",
                                            value: [
                                                (((ref = global.locationDetails) === null || ref === void 0 ? void 0 : ref.currency_symbol) || "EUR") + (0,formatBigNumber/* formatBigNumber */.d)(cur), 
                                            ],
                                            from: router
                                        });
                                        (0,we/* WE_USER_EVENT_EXPLORE_BY_PRICE_CLICKED */.c1)({
                                            priceUnderWithCurrency: (((ref1 = global.locationDetails) === null || ref1 === void 0 ? void 0 : ref1.currency_symbol) || "EUR") + (0,formatBigNumber/* formatBigNumber */.d)(cur),
                                            currency: ((ref2 = global.locationDetails) === null || ref2 === void 0 ? void 0 : ref2.currency_symbol) || "EUR",
                                            pageUrl: window.location.href
                                        }, cleverTap);
                                    // handleTileClick(cur, rangeList[i - 1] || 0);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: under_msg
                                        }),
                                        ((ref = global.locationDetails) === null || ref === void 0 ? void 0 : ref.currency_symbol) || "EUR",
                                        (0,formatBigNumber/* formatBigNumber */.d)(cur)
                                    ]
                                })
                            })
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var UnderPriceRangeSection_UnderPriceRangeSection = (UnderPriceRangeSection);


/***/ }),

/***/ 31305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ commaSeparatedFormatForNumbers; },
/* harmony export */   "d": function() { return /* binding */ formatBigNumber; }
/* harmony export */ });
var formatBigNumber = function(n) {
    if (n < 1e3) return n;
    if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
    if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
    if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
    if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
};
var commaSeparatedFormatForNumbers = function(n) {
    return n.toLocaleString("en-US", {
        minimumFractionDigits: 2
    });
};


/***/ })

}]);